import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';

const card = {
  background: '#fff',
  borderRadius: 18,
  padding: '32px 36px',
  boxShadow: '0 18px 48px rgba(20, 5, 60, 0.08)',
  border: '1px solid var(--border, #ece8f6)',
  maxWidth: 440,
  margin: '60px auto',
};

export default function Login() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!loading && user) {
      const target =
        user.role === 'admin' || user.role === 'superadmin' ? '/admin' : '/';
      navigate(target, { replace: true });
    }
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setSubmitting(true);
    try {
      await login({ email, password });
      navigate('/', { replace: true });
    } catch (e2) {
      setErr(e2.message || 'Sign-in failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mm-auth-page" style={{ padding: 24, minHeight: '100vh', background: 'var(--bg, #f7f5fc)' }}>
      <div className="mm-auth-card" style={card}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#5b21b6', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 8 }}>
          Welcome back
        </div>
        <h1 style={{ margin: '0 0 18px', fontSize: 24 }}>Sign in</h1>

        {err && (
          <div className="mm-auth-error" style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '8px 12px', fontSize: 13.5, marginBottom: 12 }}>
            {err}
          </div>
        )}

        <form onSubmit={submit} noValidate>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
            style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid var(--border, #d8d6e6)', marginBottom: 12, fontSize: 14.5 }}
          />
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid var(--border, #d8d6e6)', marginBottom: 18, fontSize: 14.5 }}
          />
          <button
            type="submit"
            className="mm-auth-primary"
            disabled={submitting}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: 10,
              border: 'none',
              background: 'linear-gradient(135deg, #5b21b6, #7c3aed)',
              color: '#fff',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 13.5, color: '#6b7280' }}>
          <Link to="/forgot-password" style={{ color: '#5b21b6' }}>Forgot password?</Link>
          <Link to="/signup" style={{ color: '#5b21b6', fontWeight: 600 }}>Create account →</Link>
        </div>
      </div>
    </div>
  );
}
